import type { Filter } from '../../../../../main/types/druidTypes';

export type NotType = 'not';

export default class NotFilter {
  type: NotType;

  field: Filter;

  dimension: void;

  values: void;

  fields: void;

  pattern: void;

  constructor(field: Filter) {
    this.type = 'not';
    this.field = field;
  }
}
